import { createSelector } from '@ngrx/store';

import { getBecomeACustomerState } from '../become-a-customer-feature.selector';
import { getOrderAddressFormState, getOrderPersonalFormState } from '../order';

export const getSmartChargingLeadState = createSelector(
  getBecomeACustomerState,
  (state) => state.smartChargingLead
);

export const getSmartChargingLeadChargingStationFormState = createSelector(
  getSmartChargingLeadState,
  (state) => state.chargingStationForm
);

export const getSmartChargingLeadLicensePlateCheckFormState = createSelector(
  getSmartChargingLeadState,
  (state) => state.licensePlateCheckForm
);

export const getSmartChargingLeadWidgetStep = createSelector(
  getSmartChargingLeadState,
  (state) => state.step
);

export const getSalesFunnelVM = createSelector(
  getOrderPersonalFormState,
  getOrderAddressFormState,
  (personalFormState, addressFormState) => {
    const salesFunnelData = {
      selectedStartDate: addressFormState.value.selectedStartDate,
      email: personalFormState.value.email,
      gender: personalFormState.value.gender,
      initials: personalFormState.value.initials,
      prefix: personalFormState.value.prefix,
      lastName: personalFormState.value.lastName,
    };
    const filled = Object.values(salesFunnelData).every((val) => !!val);

    return {
      ...salesFunnelData,
      filled,
    };
  }
);
